import ApplicationAdapter from 'cio/adapters/application';
import { ModelRegistry } from 'ember-data/model';
import DS from 'ember-data';
import { isEmpty } from '@ember/utils';

export default class RelationshipAdapter extends ApplicationAdapter {
  buildURL(
    modelName?: keyof ModelRegistry,
    id?: string,
    snapshot?: DS.Snapshot | any[] | null,
    requestType?: string,
    query?: Record<string, number | string | boolean>,
  ): string {
    /**
     * Currently "Relationships" API endpoints have 4 different URL paths for different cases:
     *
     * 1.                              "relationships/customers/related_to/:object_id"            Fetches X latest Customers that have Relationship to specific Object ("size" applies to all types)
     * 2.                              "relationships/objects/related_to/:customer_id"            Fetches X latest Objects that have Relationship to specific Customer ("size" applies to all types)
     * 3. "object_types/:object_type_id/relationships/objects/related_to/:customer_id"            Fetches X latest Objects (within Specific Object Type) that have Relationship to specific Customer ("size" applies to single specific type)
     * 4.                              "relationships/objects/related_to_all_types/:customer_id"  Fetches X latest Objects (within EACH Object Type) that have Relationship to specific Customer ("size" applies to EACH type separately)
     *
     * Best approach now is using "query" params to distinguish which endpoint should be called, as they ALL return Relationship model data
     */

    if (query != null) {
      let { customerId, objectTypeId, objectId, allObjectTypes } = query;
      if (objectId != null) {
        // case "1"
        return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/relationships/customers/related_to/${objectId}`;
      }

      if (customerId != null) {
        // cases "2|3|4"
        if (allObjectTypes === true) {
          // case "4"
          return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/relationships/objects/related_to_all_types/${customerId}`;
        }

        // case "2"
        let urlSuffix = `relationships/objects/related_to/${customerId}`;

        if (!isEmpty(objectTypeId)) {
          // case "3"
          urlSuffix = `object_types/${objectTypeId}/${urlSuffix}`;
        }
        return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/${urlSuffix}`;
      }
    }

    throw new Error('relationship requires either "customerId" or "objectId" query params');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    relationship: RelationshipAdapter;
  }
}
